var Client = /** @class */ (function () {
    function Client() {
    }
    return Client;
}());
export { Client };
